import React, { PureComponent } from "react";
import _ from "lodash";
import classNames from "classnames";
import { observer } from "mobx-react";
import TreeView from "react-treeview";

import { Labels } from "../constants/elements";
import { DropTarget } from "react-dnd";
import { ItemTypes } from "../constants/elements";
import { DragSource } from "react-dnd";
import blockStore, { selectBlock, changeBlockParent } from "../canvas/store";

import "./tree.css";

/*eslint no-mixed-operators: "off"*/

const TreeNode = p => {
  const { connectDropTarget, isOverCurrent, connectDragSource, canDrop, selectedBlock } = p;
  return connectDragSource(
    connectDropTarget(
      <div>
        <TreeView
          key={p.id}
          nodeLabel={p.renderLabel(p, isOverCurrent && canDrop, p.id === selectedBlock)}
          collapsed={!p.isOpen(p)}
          className={p.children.length > 0 ? "node" : "leaf"}
          onClick={() => p.onToggleCollapse(p)}>
          {p.children &&
            p.children.length > 0 &&
            p.children.map(blockId => <DnDTreeNode key={blockId} {...p} {...p.blocks[blockId]} />)}
        </TreeView>
      </div>
    )
  );
};

const boxTarget = {
  drop(props, monitor, block) {
    if (!monitor.didDrop()) props.onDrop(monitor.getItem().id, props.id);
  },
  canDrop(props, monitor) {
    return [ItemTypes.ELEMENT_EMPTYCONTAINER, ItemTypes.ELEMENT_SLIDER].includes(props.type);
  }
};

const collect = (connect, monitor) => {
  return {
    connectDropTarget: connect.dropTarget(),
    canDrop: monitor.canDrop(),
    isOver: monitor.isOver(),
    isOverCurrent: monitor.isOver({ shallow: true })
  };
};

const boxSource = {
  beginDrag(props, monitor) {
    return { id: props.id };
  },
  endDrag(props, monitor) {}
};

const collectSource = (connect, monitor) => {
  return { connectDragSource: connect.dragSource(), isDragging: monitor.isDragging() };
};

const DnDTreeNode = _.flow(
  DragSource(p => p.type, boxSource, collectSource),
  DropTarget(
    [
      ItemTypes.ELEMENT_TEXT,
      ItemTypes.ELEMENT_IMAGE,
      ItemTypes.ELEMENT_SLIDER,
      ItemTypes.ELEMENT_EMPTYCONTAINER,
      ItemTypes.ELEMENT_PROGRESSBAR,
      ItemTypes.ELEMENT_VIDEO,
      ItemTypes.ELEMENT_ICON
    ],
    boxTarget,
    collect
  )
)(TreeNode);

export default observer(
  class extends PureComponent {
    state = {
      opens: {}
    };

    renderLabel = (p, isOver, selected) => (
      <span
        className={classNames("tree-label", {
          over: isOver,
          selected: selected
        })}
        onClick={() => selectBlock(p.id)}>
        {p.label || Labels[p.type] || p.id}
      </span>
    );

    clickArrow = node =>
      this.setState({
        opens: Object.assign({}, this.state.opens, { [node.id]: !this.isOpen(node) })
      });

    isOpen = p => {
      return (
        this.state.opens[p.id] !== false &&
        (p.id === "canvas" || this.isChildSelected(p) || this.state.opens[p.id])
      );
    };

    isChildSelected = p =>
      p.children.reduce(
        (acc, cid) =>
          acc || blockStore.selected === cid || this.isChildSelected(blockStore.blocks.get(cid)),
        false
      );

    render() {
      return (
        <DnDTreeNode
          {...blockStore.blocks.get("canvas")}
          isOpen={this.isOpen}
          onToggleCollapse={this.clickArrow}
          blocks={blockStore.blocksTree}
          renderLabel={this.renderLabel}
          onDrop={changeBlockParent}
          selectedBlock={blockStore.selected}
        />
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/canvas/tree.js